import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import { connectRoutes } from 'redux-first-router';
import { thunk as thunkMiddleware } from 'redux-thunk';
import routesMap from './routesMap.js';
import options from './options.js';
import reducers from './reducers/index.js';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

export default () => {
    const middlewares = [thunkMiddleware];

    const storeEnhancer = (reducer, enhancer) => {
        const rootReducer = combineReducers({ ...reducers, location: reducer });
        const enhancers = composeEnhancers(enhancer, applyMiddleware(...middlewares));
        return createStore(rootReducer, enhancers);
    };

    let store;

    options.displayConfirmLeave = (message, callback) => {
        const canLeaveCallback = (can) => {
            store.dispatch({ type: 'HIDE_BLOCK_NAVIGATION_MODAL' });
            return callback(can);
        };

        store.dispatch({
            type: 'SHOW_BLOCK_NAVIGATION_MODAL',
            payload: { message, canLeaveCallback },
        });
    };

    const { reducer, middleware, enhancer } = connectRoutes(routesMap, {
        ...options,
    });
    middlewares.push(middleware);

    store = storeEnhancer(reducer, enhancer);

    return store;
};
